import Joi from 'joi';

const paginationSchema = Joi.object().keys({
  limit: Joi.number().optional().allow(null, ''),
  offset: Joi.number().optional().allow(null, ''),
  cursor: Joi.string().optional().allow(null, ''),
});

export default paginationSchema;
